import type {
  OperationsNode,
  OperationsScheduleNode,
} from '../types/operations.types'
import { isTeamNode } from './nodeTypes'

export interface DropCheck {
  dragged: OperationsNode
  draggedParent: OperationsScheduleNode | null
  targetParent: OperationsScheduleNode | null
}

/**
 * Whether a node offers a drag handle at all.
 *
 * ONLY teams drag. Divisions and conferences are ordered through the inline
 * Order cell instead, which writes `sort_order` directly — the same rule the
 * legacy Setup tab followed (`canDrag` returned true only for team nodes).
 */
export const canDragNode = (
  node: OperationsNode,
  canEdit: boolean
): boolean => {
  if (!canEdit) {
    return false
  }
  return isTeamNode(node)
}

/**
 * Whether a drop is legal.
 *
 * Teams may land in any schedule of the SAME TYPE as the one they came from —
 * reordering inside their own and moving across both go through the same
 * `/teams/:id/move` call. This mirrors legacy's own rule, which compared the
 * two parents' `subtitle` (`ScheduleTree/index.jsx:655-662`) rather than
 * hardcoding "division": a competition can hold teams directly on its root, and
 * such a team must still be movable between roots of that type.
 *
 * Nothing else drops: schedule nodes are not draggable in the first place.
 */
export const canDropNode = ({
  dragged,
  draggedParent,
  targetParent,
}: DropCheck): boolean => {
  if (!draggedParent || !targetParent) {
    return false
  }

  if (!isTeamNode(dragged)) {
    return false
  }

  return targetParent.type === draggedParent.type
}
